import angular from 'angular';
import { multiselectComponent } from './multiselectComponent';

angular
	.module('sh.multiselect', ['sh.checkboxList', 'sh.clearableInput', 'sh.zIndexTop', 'sh.focusWhen'])
	.component('shMultiselect', multiselectComponent());
